import { ACTION_STATES, ComplexAction, createHandler, createReducer } from "core/actions";

export const initState = {
    userData: null,
    formStatus: ACTION_STATES.NO_REQUEST,
    savingStatus: ACTION_STATES.NO_REQUEST,
    changePasswordStatus: ACTION_STATES.NO_REQUEST,
    uploadSignStatus: ACTION_STATES.NO_REQUEST,
};

export class LOAD_USER extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            formStatus: ACTION_STATES.SEND,
        });
    }

    successRdx(state, { payload }) {
        return {
            ...state,
            userData: payload.user,
            formStatus: ACTION_STATES.SUCCESS,
        };
    }
}

export class SAVE_USER extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            savingStatus: ACTION_STATES.SEND,
        });
    }

    successRdx(state, { payload }) {
        return {
            ...state,
            userData: payload.user,
            savingStatus: ACTION_STATES.SUCCESS,
        };
    }
    failedRdx(state, { payload }) {
        return {
            ...state,
            formError: payload,
            savingStatus: ACTION_STATES.FAILED,
        };
    }
}
export class CHANGE_PASSWORD extends ComplexAction {
    sendRdx(state) {
        return {
            ...state,
            changePasswordStatus: ACTION_STATES.SEND,
        };
    }
    successRdx(state) {
        return {
            ...state,
            changePasswordStatus: ACTION_STATES.SUCCESS,
        };
    }
    failedRdx(state, { payload }) {
        return {
            ...state,
            changePasswordError: payload,
            changePasswordStatus: ACTION_STATES.FAILED,
        };
    }
}

export class UPLOAD_SIGN extends ComplexAction {
    sendRdx(state) {
        return {
            ...state,
            uploadSignStatus: ACTION_STATES.SEND,
        };
    }
    successRdx(state) {
        return {
            ...state,
            uploadSignStatus: ACTION_STATES.SUCCESS,
        };
    }
}

export const actions = {
    LOAD_USER: new LOAD_USER(),
    SAVE_USER: new SAVE_USER(),
    CHANGE_PASSWORD: new CHANGE_PASSWORD(),
    UPLOAD_SIGN: new UPLOAD_SIGN(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const loadedUserSelector = ({ userForm }) => userForm.userData;
